import { cardSrc } from './resultParsers';
import { parseCards } from '../cards/cardUtils';

const WINNER_ICON = 'https://wver.sprintstaticdata.com/v230/static/front/img/winner.png';
const SUIT_NAME = { SS: 'Spade', HH: 'Heart', CC: 'Club', DD: 'Diamond' };

function suitOf(code) {
  return String(code).slice(-2).toUpperCase();
}
function rankOf(code) {
  return String(code).slice(0, -2).toUpperCase();
}
function oeVal(r) {
  if (r === 'A') return 1;
  if (r === 'J') return 11;
  if (r === 'Q') return 12;
  if (r === 'K') return 13;
  return parseInt(r, 10) || 0;
}
function highVal(r) {
  if (r === 'A') return 14;
  return oeVal(r);
}

// "1 : Red  |  2 : Red  |  3 : Red" — players slice, "N : val" joined by "  |  "
function descRow(players, valFn) {
  return players.map((p) => `${p.num} : ${valFn(p)}`).join('  |  ');
}

export default function WarResult({ detail }) {
  const cards = parseCards(detail?.card);
  const playerCards = cards.slice(0, 6);
  const dealerCard = cards[6] || '1';
  const dealerHigh = highVal(rankOf(dealerCard));

  // winner = detail.win (comma nums) ya rank > dealer
  const winStr = String(detail?.win ?? '');
  const winSet = new Set(winStr.split(',').map((s) => s.trim()).filter(Boolean));

  const players = playerCards.map((code, i) => {
    const num = String(i + 1);
    const suit = suitOf(code);
    const rank = rankOf(code);
    const derivedWin = highVal(rank) > dealerHigh;
    return {
      num,
      code,
      isWinner: winSet.size ? winSet.has(num) : derivedWin,
      color: (suit === 'HH' || suit === 'DD') ? 'Red' : 'Black',
      oddEven: oeVal(rank) % 2 === 1 ? 'Odd' : 'Even',
      suit: SUIT_NAME[suit] || '',
    };
  });

  const winnerText = players.filter((p) => p.isWinner).map((p) => p.num).join('  ');
  const first3 = players.slice(0, 3);
  const last3 = players.slice(3, 6);

  return (
    <div className="row row5 war-result">
      <div className="col-12 col-lg-6">
        <div className="casino-open-result">
          {players.map((p) => (
            <div key={p.num} className="casino-open-result-item">
              <h4>{p.num}</h4>
              <div className="casino-result-cards">
                <div className="casino-result-cards-item-container">
                  <div className="casino-result-cards-item">
                    <img src={cardSrc(p.code)} alt={`card-${p.num}`} />
                  </div>
                  {p.isWinner && (
                    <div className="casino-result-cards-item">
                      <img src={WINNER_ICON} className="winner-icon" alt="Winner" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
          <div className="casino-open-result-item">
            <h4 className="text-warning">D</h4>
            <div className="casino-result-cards">
              <div className="casino-result-cards-item-container">
                <div className="casino-result-cards-item">
                  <img src={cardSrc(dealerCard)} alt="dealer" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-6">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            <div>{winnerText}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Color</div>
            <div>{descRow(first3, (p) => p.color)}</div>
          </div>
          <div className="casino-result-desc-item">
            <div></div>
            <div>{descRow(last3, (p) => p.color)}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Odd/Even</div>
            <div>{descRow(first3, (p) => p.oddEven)}</div>
          </div>
          <div className="casino-result-desc-item">
            <div></div>
            <div>{descRow(last3, (p) => p.oddEven)}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Suit</div>
            <div>{descRow(first3, (p) => p.suit)}</div>
          </div>
          <div className="casino-result-desc-item">
            <div></div>
            <div>{descRow(last3, (p) => p.suit)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
